import { NOTIFICATION_TIMEOUT, showNotification } from "../../notifications";
import { DEFAULT_DOCUMENT, getFocusItem, getFocusItemDocumentList, getIsWhiteBoard, setDeleteKeyLine, setDeleteLine, SET_FOCUS_SHARE_DOCUMENT } from "../../share-document";
import { getCurrentMode } from "../../video-layout-mode";
import { getDevicePermission } from "../devices";
import { MEDIA_TYPE } from "../media";
import { getLocalParticipant, ROLE } from "../participants";
import { MiddlewareRegistry } from "../redux";
import { setCanvasProperty } from "./action";
import { SET_CAVNAS_PROPERTY } from "./actionTypes";
import { CANVAS_TOOL } from "./constants";
import "./subscriber";

MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    switch (action.type) {
        case SET_FOCUS_SHARE_DOCUMENT:
            const { uuid } = getFocusItemDocumentList(getState(), action.isWhiteBoard);
            if (action.uuid !== uuid) {
                dispatch(setCanvasProperty({ zoom: 100, isWidthFit: undefined, showOption: false }));
            }
            
            break;
        case SET_CAVNAS_PROPERTY:
            const data = action.data;

            if (data.hasOwnProperty('tool')) {
                console.log(action)
                const tool = data.tool;
                
                if (tool === CANVAS_TOOL.all_eraser) {
                    const mode = getCurrentMode(getState());
                    const isWhiteBoard = getIsWhiteBoard(mode);

                    const focusItem = data.isVod ? {
                        uuid: getState()['features/base/vod'].vod_shared_video_uuid,
                        index: 1
                    } :  getFocusItem(getState(), isWhiteBoard);

                    const localParticipant = getLocalParticipant(getState());
                    if (localParticipant.role === ROLE.PARTICIPANT) {
                        dispatch(setDeleteKeyLine(localParticipant.user_uuid, focusItem.uuid, focusItem.index));
                    } else {
                        dispatch(setDeleteLine(focusItem.uuid, focusItem.index));
                    }

                    APP.mateManagement.deletePointer(null, true, isWhiteBoard, focusItem.uuid, focusItem.index);
                    return;
                }
            }

            if (data.hasOwnProperty('showOption')) {
                // 현재 툴 
                const currentTool = getState()['features/base/canvas'].tool;
                const showOption = data.showOption;
                
                if (!showOption) {
                    switch (currentTool) {
                        case CANVAS_TOOL.text:
                            dispatch(setCanvasProperty({ tool: CANVAS_TOOL.choice }));
                            break;

                        case CANVAS_TOOL.thickness:
                        case CANVAS_TOOL.opacity:
                        case CANVAS_TOOL.color:
                        case CANVAS_TOOL.zoom:
                            dispatch(setCanvasProperty({ tool: CANVAS_TOOL.pen }));
                            break;
                    }
                }
            }

            if (data.hasOwnProperty('record')) {
                if (APP.function.record.canvasRec === false) return;
                if (action.data.record) {
                    const permissions = getDevicePermission(getState());
                    if ((permissions[MEDIA_TYPE.VIDEO] === false || permissions[MEDIA_TYPE.AUDIO] === false)) {
                        APP.UI.messageHandler.showError({
                            descriptionKey: "카메라, 오디오의 모든 권한이 있어야 녹화가 가능합니다.",
                            titleKey: "녹화 오류"
                        });
                        return;
                    }   
                }
                dispatch(showNotification({ titleKey: `notify.${action.data.record ? 'startCanvasRecord': 'stopCanvasRecord'}`}, NOTIFICATION_TIMEOUT));
            }
            break;
    }
    return next(action);
});